import React from 'react';
import { useTranslation } from 'react-i18next';
import './styles.scss';

const DeleteAccount = ({ toggleDeleteModal }) => {
  const { t } = useTranslation();

  return (
    <div className="styled-delete-account">
      <h2 className="your-data-title">{t('profile.yourDataTitle')}</h2>
      <p className="your-data-subtitle">{t('profile.yourDataSubtitle')}</p>

      <p className="delete-button-link" onClick={toggleDeleteModal}>
        {t('deleteButton.title')}
      </p>
    </div>
  );
};

export default DeleteAccount;
